//@flow

import React, { Fragment } from "react";

import FacebookIcon from "@/images/icons/social-icon-facebook.inline.svg";
import InstagramIcon from "@/images/icons/social-icon-insta.inline.svg";
import LinkedInIcon from "@/images/icons/social-icon-linkedin.inline.svg";
import PinterestIcon from "@/images/icons/social-icon-pinterest.inline.svg";
import YoutubeIcon from "@/images/icons/social-icon-youtube.inline.svg";

type Props = {
    icon: Social,
};

const SocialIcon = (props: Props): React$Element<React$ComponentType<any>> | React$Element<React$FragmentType> => {
    switch (props.icon) {
        case "instagram":
            return <InstagramIcon />;
        case "linkedin":
            return <LinkedInIcon />;
        case "pinterest":
            return <PinterestIcon />;
        case "youtube":
            return <YoutubeIcon />;
        case "facebook":
            return <FacebookIcon />;
        default:
            return <Fragment />;
    }
};

export default SocialIcon;
